import {CalculatorName} from "./Calculator";


export interface CalculatorCondition {
    value: CalculatorName;
    iconUrl: string;
    conditionTitle: string;
}

export enum CalculatorConditionsEnum {
    RATE_DROPS_BELLOW_X = "RATE_DROPS_BELLOW_X",
    EPPRAISAL_EQUITY_EXCEEDS_X = "EPPRAISAL_EQUITY_EXCEEDS_X",
    EQUITY_EXCEEDS_X = "EQUITY_EXCEEDS_X",
    MONTHLY_SAVINGS_OVER_X = "MONTHLY_SAVINGS_OVER_X"
}

export const AllCalculatorConditions: CalculatorCondition[] = [
    {
        iconUrl: '/app/images/calculations/opportunity_Rate_Reduction.jpg',
        conditionTitle: 'Rate',
        value: CalculatorName.RATE_CALCULATOR
    },
    {
        iconUrl: "/app/images/calculations/opportunity_Cash_Out.jpg",
        conditionTitle: 'Cash Out',
        value: CalculatorName.EQUITY_CASH_OUT
    },
    {
        iconUrl: '/app/images/calculations/opportunity_Payment_Savings.jpg',
        conditionTitle: 'Savings',
        value: CalculatorName.SAVINGS
    },
    {
        iconUrl: '/app/images/calculations/opportunity_Equity_Growth.jpg',
        conditionTitle: 'Mortgage Insurance Calculator',
        value: CalculatorName.EQUITY_RATE_AND_TERM_REFINANCE
    },
    {
        iconUrl: '/app/images/calculations/opportunity_Trigger_Lead.jpg',
        conditionTitle: 'Trigger Leads',
        value: CalculatorName.TRIGGER_LEADS
    }
];
